export const SET_DISTRIBUTORS_LIGHT = 'SET_DISTRIBUTORS_LIGHT'
export const SET_ROOT_CATEGORIES_LIGHT = 'SET_ROOT_CATEGORIES_LIGHT'
